import {
  useBreadcrumbRoutes,
  useTenantPermissions,
  Wrapper,
  Button,
  Select,
  Form,
  Input,
  Tabs,
  CustomFilter,
  message,
} from '@maxtropy/components';
import { Space } from 'antd';
import React, { useMemo, useState } from 'react';
import { useHasPermission } from '../../../utils/utils';

import { AlarmLevel, AlarmLevelDisplay, AlarmStatus, AlarmStatusDisplay } from '@/shared/types';
import styles from './index.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import qs from 'qs';
import {
  V2RuleGroupPagePostRequest,
  V2RulePagePostRequest,
  apiV2ComprehensiveLabelListPost,
  apiV2RuleBatchEnableOrDisablePost,
} from '@maxtropy/device-customer-apis-v2';
import { PermissionsType } from '@/common/permissionsConst';
import Rule from '@/pages/Alarm/List/Rule';
import RuleGroup from '@/pages/Alarm/List/RuleGroup';
import { useRequest } from 'ahooks';

const { Option } = Select;
// const routes = [
//   {name: 'Iot配置'},
//   {name: '报警规则'},
//   {name: '设备报警规则'},
// ];

const AlarmList: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const tabs = urlSearchParams.get('tabs') || '1';
  const [tabsKey, setTabsKey] = useState<string>(tabs);
  const hasBulkDisableRules = useHasPermission(PermissionsType.B_BULKDISABLERULES);
  const hasBatchLaunchRules = useHasPermission(PermissionsType.B_BATCHLAUNCHRULES);

  const [searchParams, setSearchParams] = useState<V2RulePagePostRequest | V2RuleGroupPagePostRequest>();
  const [ruleIds, setRuleIds] = useState<number[]>([]);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const permission = useTenantPermissions();
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const { data: labelData } = useRequest(() => apiV2ComprehensiveLabelListPost({ id: 2 }));

  const labelOptions = useMemo(() => {
    return (labelData?.list ?? []).map(item => ({ label: item.name, value: item.id }));
  }, [labelData]);

  const onFinish = (val: V2RulePagePostRequest | V2RuleGroupPagePostRequest) => {
    setSearchParams({ ...val });
    const paramsMap = new Map<string, string>();
    Object.entries(val).forEach(([key, value]) => {
      value && paramsMap.set(key, value as string);
    });
    navigate(`?${qs.stringify(Object.fromEntries(paramsMap))}`);
  };

  const onReset = () => {
    const params = {
      nameOrCode: undefined,
      status: undefined,
      type: undefined,
      alarmType: undefined,
      ruleCode: undefined,
      labelIds: undefined,
    };
    setSearchParams(params);
    navigate(`?`);
  };

  const filters = (
    <CustomFilter form={form} onFinish={val => onFinish(val as any)} onReset={onReset}>
      <Form.Item label="编号/名称" name="nameOrCode">
        <Input placeholder=" 请输入编号或名称查询" />
      </Form.Item>

      {/* {tabsKey === '1' &&
        <Col span={4}>
          <Form.Item label='规则类型' name='type'>
            <Select placeholder='请选择'>
              <Option value={AlarmType.MARGIN}>{AlarmTypeDisplay[AlarmType.MARGIN]}</Option>
              <Option value={AlarmType.SERVER}>{AlarmTypeDisplay[AlarmType.SERVER]}</Option>
            </Select>
          </Form.Item>
        </Col>
      } */}
      {tabsKey === '1' && (
        <Form.Item label="状态" name="status">
          <Select placeholder="请选择">
            <Option value={AlarmStatus.ENABLE}>{AlarmStatusDisplay[AlarmStatus.ENABLE]}</Option>
            <Option value={AlarmStatus.DISABLE}>{AlarmStatusDisplay[AlarmStatus.DISABLE]}</Option>
          </Select>
        </Form.Item>
      )}

      {tabsKey === '1' && (
        <Form.Item label="报警等级" name="alarmType">
          <Select placeholder="请选择">
            <Option value={AlarmLevel.HIGHEST}>{AlarmLevelDisplay[AlarmLevel.HIGHEST]}</Option>
            <Option value={AlarmLevel.HIGH}>{AlarmLevelDisplay[AlarmLevel.HIGH]}</Option>
            <Option value={AlarmLevel.MIDDLE}>{AlarmLevelDisplay[AlarmLevel.MIDDLE]}</Option>
            <Option value={AlarmLevel.LOW}>{AlarmLevelDisplay[AlarmLevel.LOW]}</Option>
            <Option value={AlarmLevel.LOWEST}>{AlarmLevelDisplay[AlarmLevel.LOWEST]}</Option>
          </Select>
        </Form.Item>
      )}
      {tabsKey === '1' && (
        <Form.Item name="labelIds" label="报警规则标签">
          <Select
            placeholder="请选择"
            options={labelOptions}
            allowClear
            mode="multiple"
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
      )}
      {tabsKey === '2' && (
        <Form.Item label="规则编号" name="ruleCode">
          <Input placeholder=" 请输入编号查询" />
        </Form.Item>
      )}
    </CustomFilter>
  );

  const onChangeTabs = (v: string) => {
    setTabsKey(v);
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.delete('tabs');
    urlSearchParams.append('tabs', v);
    navigate(`?${urlSearchParams.toString()}`);
  };

  const handleSelectChange = (keys: React.Key[]) => {
    setRuleIds(keys.map(key => Number(key)));
  };

  const handleBatchDisable = async (key: string) => {
    if (ruleIds.length === 0) {
      message.error('请选择需要批量处理的规则');
      return;
    }
    const res = await apiV2RuleBatchEnableOrDisablePost({ ruleIds, status: key });
    if (res.flag) {
      setRefreshFlag(prev => prev + 1);
    }
  };
  return (
    <Wrapper routes={breadcrumbRoutes?.routes} filters={filters} className="page_wrapper">
      <div className={styles.operationArea}>
        <Space size={8}>
          {(permission ?? []).includes(PermissionsType.B_CREATE_RULE) && (
            <Button type="primary">
              <Link to={`/device/rule/list/create?tabs=${tabsKey}`}>
                <PlusOutlined />
                新建规则
              </Link>
            </Button>
          )}
          {(permission ?? []).includes(PermissionsType.B_CREATE_RULE_GROUP) && (
            <Button type="primary">
              <Link to={`/device/rule/list/group/create?tabs=${tabsKey}`}>
                <PlusOutlined />
                新建规则组
              </Link>
            </Button>
          )}
          {tabsKey === '1' && hasBulkDisableRules && (
            <Button type="primary" onClick={() => handleBatchDisable('1')}>
              批量禁用
            </Button>
          )}
          {tabsKey === '1' && hasBatchLaunchRules && (
            <Button type="primary" onClick={() => handleBatchDisable('0')}>
              批量启用
            </Button>
          )}
        </Space>
      </div>
      <Tabs
        defaultActiveKey={tabs}
        tabBarStyle={{
          marginBottom: 3,
        }}
        tabBarGutter={43}
        className={styles.tabs}
        onChange={v => onChangeTabs(v)}
      >
        <Tabs.TabPane tab="规则" key="1">
          <Rule
            searchParams={searchParams}
            permission={permission ?? []}
            tabsKey={tabsKey ?? '1'}
            onSelectChange={handleSelectChange}
            refreshFlag={refreshFlag}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="规则组" key="2">
          <RuleGroup searchParams={searchParams} permission={permission ?? []} tabsKey={tabsKey ?? '1'} />
        </Tabs.TabPane>
      </Tabs>
    </Wrapper>
  );
};

export default AlarmList;
